import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

export interface PingResponse {
  message: string;
  service: string;
  status: string;
  database: string;
  timestamp: string;
}

/**
 * Faz o "ping" na API essential-tickets. A chamada usa o caminho relativo
 * /api/ping, que em desenvolvimento e redirecionado para o backend via
 * proxy.conf.json.
 */
@Injectable({ providedIn: 'root' })
export class PingService {
  private readonly http = inject(HttpClient);

  ping(): Observable<PingResponse> {
    return this.http.get<PingResponse>('/api/ping');
  }
}
